import { FunctionComponent, HTMLAttributes } from 'react';

const IconCheck: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => (
  <svg
    {...props} width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M31.3999 0.571575C32.1888 1.34469 32.2016 2.61096 31.4284 3.39986L11.8284 23.3999C11.0806 24.163 9.865 24.2035 9.06799 23.4919L0.667988 15.9919C-0.155952 15.2562 -0.227516 13.9919 0.508145 13.168C1.24381 12.344 2.50811 12.2725 3.33205 13.0081L10.3079 19.2366L28.5716 0.600143C29.3447 -0.188754 30.611 -0.201545 31.3999 0.571575Z" fill="currentcolor" />
  </svg>

);

export default IconCheck;
